import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as pageAction from './../../../../../actions/pageAction';
import * as postAction from './../../../../../actions/postAction';
import * as categoryAction from './../../../../../actions/categoryAction';
import PostDetail from './PostDetail';
import {uploadAction} from "../../../../../actions/uploadAction";

const mapStateToProps = state => {
    return {
        postState: state.postReducer,
        categoryState: state.categoryReducer,
        uploadState: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPostDetail: (id) => dispatch(postAction.getPostDetail(id)),
        getListAllCategories: () => dispatch(categoryAction.getListAllCategories()),
        setPostDetail: (post) => dispatch(postAction.setPostDetail(post)),
        updatePostDetail: (post) => dispatch(postAction.updatePostDetail(post)),
        createPostDetail: (post) => dispatch(postAction.createPostDetail(post)),
        onUploadFile: (filters) => dispatch(uploadAction(filters)),
        createPostTranslate: (post, language) => dispatch(postAction.createPostTranslate(post, language)),
        updatePostTranslate: (post, language) => dispatch(postAction.updatePostTranslate(post, language)),
        deletePostTranslate: (post, refreshParams) => dispatch(postAction.deletePostTranslate(post, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PostDetail));
